/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.meetings.rpc.CustomEmailRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getCustomConfirmationForLinkRpc = {
  serviceName: 'com.hubspot.meetings.rpc.CustomEmailRpc',
  rpcName: 'getCustomConfirmationForLink',
  auth: 'app',
  fingerprint: 'OfMplQ369CikleN72WpN47P2N_K8OkaH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createCustomConfirmationForLinkRpc = {
  serviceName: 'com.hubspot.meetings.rpc.CustomEmailRpc',
  rpcName: 'createCustomConfirmationForLink',
  auth: 'app',
  fingerprint: 'ImCwAToeAUOOUe2e_r4XmTHqfEjdz2CV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCustomConfirmationForLinkRpc = {
  serviceName: 'com.hubspot.meetings.rpc.CustomEmailRpc',
  rpcName: 'deleteCustomConfirmationForLink',
  auth: 'app',
  fingerprint: 'OfMplQ369CiOUe2e_r4XmRpBKHb3T1ra',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};